import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DocumentSender } from '../common-components/document-sender-picker/document-sender-picker.component';

@Injectable({ providedIn: 'root' })
export class CurrentUserOverrideStateService {
  private readonly subject = new BehaviorSubject<DocumentSender | null>(null);
  /** null = acting as the logged-in user (no override). */
  readonly override$ = this.subject.asObservable();

  get current(): DocumentSender | null {
    return this.subject.value;
  }

  select(sender: DocumentSender): void {
    this.subject.next(sender);
  }

  clear(): void {
    this.subject.next(null);
  }
}
